module.exports = __webpack_public_path__ + "static/media/leiseca.93535332.png";